module.exports = __webpack_public_path__ + "static/media/14_nature.176cde57.jpg";